// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.cat_box[data-v-31084f78] {\n        list-style-type: none;\n        padding-left:0;\n}\n.cat_box.not_root[data-v-31084f78]{\n        position: relative;\n        padding-left:15px;\n        background: #fefefe;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
